export default "__VITE_ASSET__Cp8klIJU__"